<template lang="pug">
.control.editable(:id="id" :class="controlClasses")
  ul.errors(v-if="errors.length > 0")
    li.error(v-for="error in errors" :key='error.id || error.fieldName') {{ error.message }}

  .state-wrapper
    .edit-wrapper(v-if="editing" :class="editClasses" @click="onEdit")
      .edit
        slot

    .view-wrapper(v-else @click="onEdit" :class="viewClasses")
      .view
        router-link.label(v-if="navigationRoute" :to="navigationRoute") {{ displayValue || "\xa0" }}
        a.label(v-else-if="hrefLinkPrefix && displayValue" :href="hrefLinkPrefix + ':' + displayValue") {{ displayValue || "\xa0" }}
        label(v-else :disabled="isDisabled") {{ displayValue || "\xa0" }}
        slot(name="icons")
</template>

<script>
import Vue from "vue";
import { BLOCK, Events } from "../Block/index";
import { onActive } from "./mixins";
import "./scss";

export default {
  name: "EditableControl",
  props: {
    bus: {
      type: Vue,
      required: true,
    },
    editing: {
      type: Boolean,
    },
    editByDefault: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      required: true,
    },
    navigationRoute: {
      type: String,
      default: undefined,
    },
    hrefLinkPrefix: {
      type: String,
      default: undefined,
    },
    value: {
      type: null,
      default: undefined,
    },
    displayValue: {
      type: [String, Date, Function],
      default: () => "",
    },
    saved: {
      type: Boolean,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      blockEditing: false,
      dirty: false,
      saving: false,
    };
  },
  computed: {
    controlClasses() {
      const classes = [];
      if (this.editing) {
        classes.push("editing");
      }

      if (this.dirty) {
        classes.push("dirty");
      }

      if (this.saved) {
        classes.push("saved");
      }

      if (this.errors.length > 0) {
        classes.push("errors");
      }

      return classes;
    },
    editClasses() {
      const classes = this.editByDefault ? ["edit-by-default"] : [];
      if (this.errors.length > 0) {
        classes.push("errors");
      }

      if (this.active) {
        classes.push("active");
      }

      return classes;
    },
    viewClasses() {
      return this.errors.length > 0 ? "errors" : [];
    },
  },
  created() {
    this.bus.$on(Events.Active, this.onActive);
    this.bus.$on(Events.Dirty, this.onDirty);
    this.bus.$on(Events.Edit, this.onEditing);
  },
  destroyed() {
    this.bus.$off(Events.Active, this.onActive);
    this.bus.$off(Events.Dirty, this.onDirty);
    this.bus.$off(Events.Edit, this.onEditing);
  },
  methods: {
    onActive,
    onDirty({ id, state }) {
      if (id === this.id && this.dirty !== state) {
        this.dirty = state;
      }
    },
    onEditing({ id, state }) {
      if (id === BLOCK && this.blockEditing !== state) {
        this.blockEditing = state;
      }
    },
    onEdit() {
      if (this.blockEditing && !this.editing) {
        this.$emit(Events.Edit, this.id);
      }
    },
  },
};
</script>
